import { IPrefillData   } from 'common/components/freshdesk-widget/interfaces/freshdesk-widget.interfaces.ts';

declare global {
  interface Window {
    fwSettings?: { widget_id: number };
    FreshworksWidget?: (action: string, key?: string, value?: IPrefillData | string[]) => void;
  }
}

export const initializeFreshdesk = (): void => {
  if (typeof window !== 'undefined') {
    window.fwSettings = {
      widget_id: 201000001215,
    };

    ((): void => {
      const script = document.createElement('script');
      script.src = `https://euc-widget.freshworks.com/widgets/201000001215.js`;
      script.async = true;
      script.defer = true;
      script.onload = (): void => {
        let attempts = 0;
        const interval = setInterval(() => {
          if (window.FreshworksWidget) {
            try {
              window.FreshworksWidget('hide', 'launcher');
              clearInterval(interval);
              return;
            } catch {
              // widget iframe not yet mounted; retry next tick
            }
          }
          attempts += 1;
          if (attempts >= 20) clearInterval(interval);
        }, 500);
      };
      document.body.appendChild(script);
    })();
  }
};

export const openFreshdeskForm = (prefillData: IPrefillData): void => {
  if (typeof window !== 'undefined' && window.FreshworksWidget) {
    window.FreshworksWidget(
      'disable',
      'ticketForm',
      [
        prefillData.name ? 'name' : '',
        prefillData.email ? 'email' : '',
      ]
    );
    window.FreshworksWidget('open');
    window.FreshworksWidget('prefill', 'ticketForm', prefillData);
  }
};
